import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import { DraggableType } from '../../../types/dnd';
import Grid from '../../../Grid';
import { DndSortable, DndSortableElement, } from '../../../Dnd/DndSortable';
import { isGallectionManageable } from '../../helpers';
import s from './GallectionGrid.scss';
var GallectionGrid = /** @class */ (function (_super) {
    __extends(GallectionGrid, _super);
    function GallectionGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFolderId = function (index) {
            var _a = _this.props.gallections, gallections = _a === void 0 ? [] : _a;
            var item = gallections[index];
            return item.folderId;
        };
        _this.renderDndGallection = function (_a) {
            var draggedElementId = _a.draggedElementId, dndProps = __rest(_a, ["draggedElementId"]);
            return function (options) {
                var _a = _this.props, gallectionRenderer = _a.gallectionRenderer, _b = _a.gallections, gallections = _b === void 0 ? [] : _b, moveGallectionToPosition = _a.moveGallectionToPosition;
                var style = options.style, index = options.index;
                var item = gallections[index];
                var canMove = isGallectionManageable(item) && !!moveGallectionToPosition;
                if (!canMove) {
                    return React.createElement("div", { style: style }, gallectionRenderer(options));
                }
                var isDragging = draggedElementId === item.folderId;
                return (React.createElement(DndSortableElement, __assign({ dndType: DraggableType.MEDIA_MANAGER_GALLECTION, id: item.folderId, key: item.folderId, position: index, isSortable: canMove }, dndProps), function (sortableOptions) { return (React.createElement("div", { id: "".concat(item.folderId), ref: sortableOptions.ref, key: item.folderId, style: {
                        marginLeft: style.marginLeft,
                    }, className: classnames(isDragging && s['dragging']) }, gallectionRenderer(options))); }));
            };
        };
        _this.onDndDragOver = function (id, position) {
            _this.props.moveGallectionToPosition({
                folderId: id,
                position: position,
                moveType: 'streamOnly',
            });
        };
        _this.onDndDrop = function (id, position) {
            _this.props.moveGallectionToPosition({
                folderId: id,
                position: position,
                moveType: 'papiOnly',
            });
        };
        return _this;
    }
    GallectionGrid.prototype.render = function () {
        var _this = this;
        var _a = this.props, gallections = _a.gallections, cookieType = _a.cookieType, isMobile = _a.isMobile;
        if (!gallections) {
            return null;
        }
        return (React.createElement(DndSortable, { onDragOver: this.onDndDragOver, onDrop: this.onDndDrop }, function (props) {
            var renderElement = _this.renderDndGallection(props);
            return (React.createElement(Grid, { className: s['root'], breakpoints: [
                    { maxWidth: 0, elementWidth: 130, elementHeight: 106 },
                    { maxWidth: 451, elementWidth: 270, elementHeight: 220 },
                ], cookieType: cookieType, elementCount: gallections.length, getElementId: _this.getFolderId, renderElement: renderElement, spacing: isMobile ? 10 : 16, enableScrollOptim: false }));
        }));
    };
    return GallectionGrid;
}(React.Component));
export { GallectionGrid };
export default withMobileContext(GallectionGrid);
//# sourceMappingURL=GallectionGrid.js.map